




































import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import FileApi from "../../../../File/logic/file-api";
import { MessageAttachment } from '../../../../NewMessageEditors/NewMessageEditorWithMedia/Media/types'
import MessageEditorWithMediaData from '../../../../NewMessageEditors/NewMessageEditorWithMedia/types'

@Component({
})
export default class NodeMessagePreview extends Vue {
  @Prop() messages!: Array<MessageEditorWithMediaData>

  @Prop() target!: string

  @Prop() i18n!: VueI18n

  fileApi = new FileApi()

  get firstMessageAttachments(): Array<MessageAttachment> {
    return this.messages[0]?.attachments ?? []
  }
}
